module.exports = __webpack_public_path__ + "static/media/fun4.cbeb71dc.png";